import { useState } from 'react'
import { useSelector } from 'react-redux'
import { SvgIcon, SvgType } from '../../common/svgIcon/SvgIcon'
import { IntroVidWrap } from './styled'

const Intro = ({ skipVid }: { skipVid: () => void }) => {
  const [muted, setMuted] = useState(true)
  const { videos } = useSelector((state: any) => state.assetCache)

  const introVid = videos.find((video: any) => video.fileName === 'introVid')

  const toggleMute = () => {
    setMuted(!muted)
  }

  return (
    <IntroVidWrap>
      <button
        className="skipBtn btn btn-outline-danger btn-sm"
        onClick={skipVid}
      >
        SKIP
      </button>
      <button className="unmuteBtn btn" onClick={toggleMute}>
        {muted ? (
          <SvgIcon type={SvgType.MUTED} />
        ) : (
          <SvgIcon type={SvgType.UNMUTED} />
        )}
      </button>
      <video autoPlay muted={muted} id="introVid" onEnded={skipVid}>
        <source src={introVid?.blob} type="video/mp4" />
      </video>
    </IntroVidWrap>
  )
}

export default Intro
